import {handleLogout} from "components/utils";
import React, {forwardRef, useEffect, useImperativeHandle, useRef, useState} from 'react';
import {Accordion, Button, Card, Col, Form, Modal, Row} from "react-bootstrap";
import axios from "axios";
import 'react-vertical-timeline-component/style.min.css';
import Editor from 'react-simple-wysiwyg';
import {IpdPrescriptionWritingView} from "../../IpdPrescriptionWritingView";
import {DischargeSummary} from "../DischargeSummary";
import {useCookies} from "react-cookie";
import DatePicker from "react-datepicker";
import {hasPermissions, IPD_BILLING, IPD_DISCHARGE} from "../../../permissions";
import {RichEditor} from "../../consentForms/RichEditor";

export const AddDischargeDetailsView = (props: { cookieEntityQr: string, postAction: any, doctors: Array<any>, id: any, caseDetails: any }) => {


    const [successMessage, setSuccessMessage] = useState(null);
    const [loading, setLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState(null);
    const [dischargeItem, setDischargeItem] = useState(null);
    const [patientStatus, setPatientStatus] = useState("DISCHARGE");
    const [followUpDate, setFollowUpDate] = useState<Date>(new Date(Date.now() + 3));
    const [approvers, setApprovers] = useState({});
    const [qrCode, setQrCode] = useState<string>(null);
    const [prCategory, setPrCategory] = useState<string>(null);
    const [prescId, setPrescId] = useState<string>(null);
    const [lineItems, setLineItems] = useState([]);
    const [notes, setNotes] = useState(null);
    const [cookie] = useCookies(['qme']);

    useEffect(() => {

        fetchDischargeDetails(props.id, props.cookieEntityQr)

    }, [props.id])


    function fetchDischargeDetails(caseId, entityQr) {
        axios.get('/api/backend/ipd/case/audit/fetch/all/' + entityQr + "/" + caseId)
            .then(resp => {
                console.log(JSON.stringify(resp.data))
                const dischargeEntry = resp.data.filter((entry) => entry.type == "DISCHARGE_SUMMARY")
                if (dischargeEntry && dischargeEntry.length > 0) {
                    const dischargeItem = dischargeEntry[0]
                    setDischargeItem(dischargeItem)
                    setNotes(dischargeItem.notes)
                    setPrescId(dischargeItem.presId)
                    if (dischargeItem.patientStatus) setPatientStatus(dischargeItem.patientStatus)
                    if (dischargeItem.extraDetails) {
                        setApprovers(JSON.parse(dischargeItem.extraDetails))
                        if (JSON.parse(dischargeItem.extraDetails).follow_up_date) setFollowUpDate(new Date(JSON.parse(dischargeItem.extraDetails).follow_up_date))
                    }
                }
            })
            .catch(err => {
                console.error(err);
                if (err.response && err.response!.status && err.response!.status === 403) {
                    handleLogout()
                }
            })
    }

    const [showDischargeModal, setShowDischargeModal] = useState(false);
    const handleCloseDischargeModal = () => setShowDischargeModal(false);
    const handleShowDischargeModal = async () => {
        await handleAddDischargeRemarks(false)
        setShowDischargeModal(true)
    }

    function getModalForDischarge() {
        return <Modal
            show={showDischargeModal}
            onHide={handleCloseDischargeModal}
            backdrop="static"
            className="modal-xl"
        >
            <Modal.Header closeButton/>
            <Modal.Body>
                <Card>
                    <Card.Header className="text-info fw-bold">Preview</Card.Header>
                    <Card.Body>
                        {props.caseDetails && <DischargeSummary trackId={props.caseDetails.trackId} isFromLink={false}
                                                                doctors={props.doctors} isPreview/>}
                    </Card.Body>
                </Card>
                <div className="my-2">
                    <button className="btn btn-info text-white btn-sm" onClick={handleCloseDischargeModal}>
                        Back
                    </button>
                    &nbsp;
                    <button className="btn btn-success text-white btn-sm" onClick={handleDischargePatient}>
                        Confirm
                    </button>
                </div>
            </Modal.Body>
        </Modal>;
    }

    useEffect(() => {

        if (props.caseDetails && props.doctors && props.doctors.filter(dr => dr.id == props.caseDetails.assignedDrId).length > 0) {
            setQrCode(props.doctors.filter(dr => dr.id == props.caseDetails.assignedDrId)[0]["qrCode"])
            setPrCategory(props.doctors.filter(dr => dr.id == props.caseDetails.assignedDrId)[0]["category"])
        }

    }, [props.caseDetails])


    async function saveDischargeData(callPostAction: boolean) {
        var url
        if (dischargeItem && dischargeItem.id) {
            url = '/api/backend/ipd/case/audit/update/' + dischargeItem.id
        } else {
            url = '/api/backend/ipd/case/audit/create'
        }
        axios.post(url, {
            entityQr: props.cookieEntityQr,
            caseId: props.id,
            notes: notes,
            lineItems: lineItems,
            clientQr: qrCode,
            prCategory: prCategory,
            patientStatus: patientStatus,
            extraDetails: JSON.stringify({...approvers, follow_up_date: followUpDate}),
            type: "DISCHARGE_SUMMARY"
        }).then(resp => {
            console.log(resp.data)
            fetchDischargeDetails(props.id, props.cookieEntityQr)
            if (callPostAction) {
                props.postAction()
            }
        })
            .catch(err => {
                console.error(err);
                if (err.response && err.response!.status && err.response!.status === 403) {
                    handleLogout()
                }
                ;
                setErrorMessage("Error while creating the Discharge Entry")
            });
    }

    const handleAddDischargeRemarks = async (callPostAction: boolean) => {
        await saveDischargeData(callPostAction);
    };

    const handleDischargePatient = () => {
        axios.post('/api/backend/ipd/case/update/status/' + props.id + '/DISCHARGED', null)
            .then(resp => {
                console.log(resp.data)
                props.postAction()
            })
            .catch(err => {
                console.error(err);
                if (err.response && err.response!.status && err.response!.status === 403) {
                    handleLogout()
                }
                ;
            })
    }

    return (
        <>
            <div className="pt-2">
                <Form.Label className="text-info fs-7">Discharge Type</Form.Label>
                <select className="form-select form-select-sm" value={patientStatus}
                        onChange={e => setPatientStatus(e.target.value)}
                >
                    <option value="DISCHARGE">Patient Discharge</option>
                    <option value="DEATH">Death</option>
                    <option value="LAMA">Leave against medical advise</option>
                    <option value="DISCHARGE ON REQUEST">Discharge on request</option>
                </select>
                {qrCode &&
                    <>
                        <Accordion className="my-2">
                            <Accordion.Item eventKey="0">
                                <Accordion.Header className="accordian-base-colour">
                                    <div className="text-info"> Discharge Prescription</div>
                                </Accordion.Header>
                                <Accordion.Body>
                                    <IpdPrescriptionWritingView entityQr={props.cookieEntityQr} isEditable={true}
                                                                qrCode={qrCode}
                                                                id={prescId}
                                                                setLineItems={setLineItems}/>
                                </Accordion.Body>
                            </Accordion.Item>
                        </Accordion>
                    </>}
                <Form.Label className="text-info fs-7">Discharge Remarks</Form.Label>
                <RichEditor data={notes} setData={setNotes} height={500}/>
                <div className="d-flex gap-2 my-2 justify-content-between">
                    <Form.Label className="text-info fs-7 text-nowrap align-self-center">Follow-up Date</Form.Label>
                    <DatePicker className="form-control form-control-sm" selected={followUpDate}
                                onChange={(date: Date) => setFollowUpDate(date)}
                                dateFormat="dd/MM/yyyy"/>
                </div>
                <div className="d-flex gap-2 my-2 justify-content-between">
                    <div className="d-flex gap-2 flex-fill">
                        <Form.Label className="text-info fs-7 text-nowrap align-self-center">Clinical
                            Approver</Form.Label>
                        <input className="form-control form-control-sm"
                               placeholder="Name of the approver"
                               disabled={!hasPermissions(cookie.qme, IPD_DISCHARGE)}
                               onChange={e => setApprovers({
                                   ...approvers,
                                   clinical_approver: e.target.value
                               })}
                               value={approvers["clinical_approver"]}/>
                    </div>
                    <div className="d-flex gap-2 flex-fill">
                        <Form.Label className="text-info fs-7 text-nowrap align-self-center">Accounts
                            Approver</Form.Label>
                        <input className="form-control form-control-sm"
                               placeholder="Name of the approver"
                               disabled={!hasPermissions(cookie.qme, IPD_DISCHARGE)}
                               onChange={e => setApprovers({
                                   ...approvers,
                                   accounts_approver: e.target.value
                               })}
                               value={approvers["accounts_approver"]}/>
                    </div>
                </div>
            </div>
            {getModalForDischarge()}
            <div className="pt-4">
                <button className="btn btn-info text-white btn-sm" onClick={e => handleAddDischargeRemarks(true)}>
                    Save Details
                </button>
                &nbsp;&nbsp;
                <button className="btn btn-success text-white btn-sm" onClick={handleShowDischargeModal}
                        disabled={!(approvers["accounts_approver"] && approvers["clinical_approver"] && hasPermissions(cookie.qme, IPD_DISCHARGE))}
                >
                    Discharge Patient
                </button>
            </div>
            {!hasPermissions(cookie.qme, IPD_DISCHARGE) &&
                <div className="fs-7 text-warning">You don&apos;t have the permissions to discharge a Patient. Please
                    contact your admin.</div>}
        </>
    );
}